import { CategoriePa } from "./document-pa.entity";
import { TypeDocumentPa } from "../entities/document-pa.entity";

export class DocumentPersonneAvertieResult {
  id!: number;
  numeroPa!: string;
  typeDocumentPa!: TypeDocumentPa;
  description!: string;
  etat!: string;
  dateDebut!: number[];
  dateFin!: number[];
  lien!: string;
  actif!: boolean;
  duree!: number;
  version!: number;
  obsolete!: boolean;
  nombreIntervenants!: number;
  versionTechnique!: number;
  lastCompletedStep!: number;
  agenceId!: number;
  nomEntreprises!: string;
  idEntreprises!: string;
  parcIds!: string;
  parcCodes!: string;
  parcActif!: boolean;
  parcDescription!: string;
  referentParcId!: number;
  groupementIds!: string;
  antenneId!: number;
  
  expired!: boolean;
  categorie!: CategoriePa;
  duplicatedId!: number;
  commune!: string;
  horaires!: string;
}
